// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__76U8R","wrapper":"styles_wrapper__eLPuW","input":"styles_input__F3Vr1"};